(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyServantsV2DialogController', CompanyServantsV2DialogController);

    CompanyServantsV2DialogController.$inject = ['__config', '$timeout', '$scope', '$stateParams', '$state', 'entity', 'Servant', 'PersonInfo', 'ServiceCategory', 'ServiceItem', 'PriceInfo', 'ServantCustom', 'CompanyCustom', '$translate', '$mdToast', '$mdDialog', '$rootScope', 'Principal', 'ActivityTypeInfoCustom', 'ServiceItemCustom', 'PackageFeatureListCustom'];

    function CompanyServantsV2DialogController(__config, $timeout, $scope, $stateParams, $state, entity, Servant, PersonInfo, ServiceCategory, ServiceItem, PriceInfo, ServantCustom, CompanyCustom, $translate, $mdToast, $mdDialog, $rootScope, Principal, ActivityTypeInfoCustom, ServiceItemCustom, PackageFeatureListCustom) {
        var vm = this;

        vm.scope = $scope;
        vm.servant = entity;
        vm.$state = $state;
        vm.hasEoTimeRange = false;
        if (vm.servant && vm.servant.id != null) {
            var now = new Date();
            now.setDate(now.getDate() - 1);
            now.setHours(0);
            now.setMinutes(0);
            now.setSeconds(0);
            var tempArr = [];
            vm.showAmenities = false;
            vm.showImageGallery = false;
            vm.showTags = false;
            vm.isWorkSpace = false;
            vm.servantTranslate = $translate.instant('tikonApp.servant.home.title');
            vm.__config = __config;
            vm.showLimitDates = false;
            vm.showLimitDateChange = showLimitDateChange;
            vm.addClosedTimes = addClosedTimes;
            vm.addOpenTimes = addOpenTimes;
            vm.setTabActive = setTabActive;


            angular.forEach(vm.servant.scheduleInfo.scheduleExceptionDurations, function (exDate) {
                if (new Date(exDate.startDate) > now) {
                    tempArr.push(exDate);
                }
            })
            vm.servant.scheduleInfo.scheduleExceptionDurations = tempArr;
        }
        // vm.servant.status = 'ACTIVE';
        vm.clear = clear;
        vm.save = save;
        vm.tabSelector = tabSelector;
        vm.orderedTabSelected = true;
        //vm.personinfos = PersonInfo.query();
        vm.serviceList = [];
        vm.hasNotNewSchedule = hasNotNewSchedule;
        vm.hasNewSchedule = hasNewSchedule;
        vm.setEdited = setEdited;
        vm.updatePrice = updatePrice;
        vm.editBtnPressed = [];
        vm.showServantSchedule = true;
        vm.showServantCloseTimes = false;
        vm.getNavItemClass = getNavItemClass;
        vm.serviceListEmptyMessage = "این پرسنل هیچ خدمتی ارائه نمی دهد";


        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;
        vm.allCompanyServiceList = [];
        vm.onServantServiceCheckChange = onServantServiceCheckChange;
        vm.onServiceServantScheduleTabClick = onServiceServantScheduleTabClick;
        vm.isServiceScheduleLoading = false;
        vm.isServiceScheduleLoaded = false;
        vm.hasServantServiceSchedulingFeature = false;
        vm.customPricingForServant = false;

        loadAll();

        function loadAll() {


            $rootScope.$broadcast('hideNavBar');
            window.scroll(0, 0);
            loadAllCompanyServiceList();
            // loadServantServiceSchedules();
            hasServantServiceSchedulingFeature();
            hasCustomPricingForServantFeature();

            checkAccess();
            checkShowLimitDates();
        }

        function checkAccess() {

            vm.isServantLogin = false;

            Principal.hasAuthority('ROLE_SERVANT_LOGIN')
                .then(function (result) {
                    if (result)
                        vm.isServantLogin = true;
                    else
                        vm.isServantLogin = false;
                })
        }

        function hasServantServiceSchedulingFeature() {

            PackageFeatureListCustom.getPackageFeatureListByCurrentCompany().query().$promise.then(function (result) {
                Principal.setCurrentCompanyFeatureList(result);
                vm.hasServantServiceSchedulingFeature = Principal.hasSpecialFeatureAccess('servantServiceScheduling');
            })

        }

        function hasCustomPricingForServantFeature() {

            PackageFeatureListCustom.getPackageFeatureListByCurrentCompany().query().$promise.then(function (result) {
                Principal.setCurrentCompanyFeatureList(result);
                vm.customPricingForServant = Principal.hasSpecialFeatureAccess('customPricingForServant');
            })

        }

        checkCompanyActivityType();
        // $scope.$watch('vm.servant', function (servant) {
        // })

        // $timeout(function (){
        //     angular.element('.form-group:eq(1)>input').focus();
        // });

        function loadAllCompanyServiceList() {
            if (!vm.servant || !vm.servant.id)
                return;
            ServiceItemCustom.getServiceItemWithServantsByCurrentCompany().query(function (result) {
                vm.allCompanyServiceList = result;
                ServiceItemCustom.getServiceItemsByServantId(vm.servant.id).query(function (list) {
                    vm.allServantServices = list;
                    makeServantServiceList();
                })

            });
        }

        function makeServantServiceList() {
            angular.forEach(vm.allCompanyServiceList, function (allItem) {
                angular.forEach(vm.allServantServices, function (service) {
                    if (allItem.id == service.id)
                        allItem.checked = true;
                })
                if (allItem.serviceMode && allItem.serviceMode == 'EVENT')
                    allItem.canRemoveCheck = false;
                else {
                    if (allItem.servants && allItem.servants.length > 1) {
                        allItem.canRemoveCheck = true;
                    } else {
                        allItem.canRemoveCheck = false;
                    }
                }
            })
        }

        function clear() {
            // $uibModalInstance.dismiss('cancel');
        }

        function tabSelector() {
            vm.orderedTabSelected = !vm.orderedTabSelected;
        }

        function save() {

            if (vm.isWorkSpace)
                vm.servant.personInfo.lastName = ' ';

            prepareServiceItemListForSave();

            vm.isSaving = true;

            if (vm.servant.id !== null) {
                Servant.update(vm.servant, onSaveSuccess, onSaveError);
            } else {
                Servant.save(vm.servant, function (result) {

                    if ($state.current.parent == 'supplierPanel-v2.dashboard') {
                        $rootScope.$broadcast('showNavBar');
                        $state.go('supplierPanel-v2.dashboard');
                    } else
                        $state.go('supplierPanel-v2.companyServants.edit', {id: result.id});

                }, onSaveError);
            }
        }

        function onSaveSuccess(result) {

            if (vm.isServiceScheduleLoaded) {
                ServantCustom.saveScheduleList().update(vm.serviceList, function () {
                    $scope.$emit('tikonApp:servantUpdate', result);
                    // vm.serviceList=ServantCustom.serviceItemScheduleByServantId(servant.id).query(function(result){
                    //     vm.servant=result;
                    // });

                    vm.isSaving = false;

                })
            } else {
                vm.isSaving = false;
            }


            if (result.videoCallSettingInfo && result.videoCallSettingInfo.id) {
                vm.servant.videoCallSettingInfo = result.videoCallSettingInfo;
            }

            $timeout(function() {
                loadAllCompanyServiceList();
                loadServantServiceSchedules();
            },100)

        }

        function loadServantServiceSchedules() {

            if (!vm.hasServantServiceSchedulingFeature && !vm.customPricingForServant) {
                vm.isServiceScheduleLoading = false;
                vm.isServiceScheduleLoaded = false;
                return;
            }


            if (vm.servant) {
                if (vm.servant.scheduleInfo && !vm.servant.scheduleInfo.baseScheduleMode)
                    vm.servant.scheduleInfo.baseScheduleMode = 'BASED_ON_COMPANY';
                if (vm.servant.id)
                    vm.isServiceScheduleLoading = true;
                vm.isServiceScheduleLoaded = false;

                ServantCustom.serviceItemScheduleByServantId(vm.servant.id).query(function (result) {
                    vm.serviceList = result;
                    checkShowLimitDates();
                    vm.isServiceScheduleLoading = false;
                    vm.isServiceScheduleLoaded = true;

                });

            }
        }

        function setEdited(ssi) {

            ssi.edited = (!ssi.edited);
        }

        function hasNewSchedule(ssi) {
            ssi.scheduleInfo.hasNewSchedule = true;
        }

        function hasNotNewSchedule(ssi) {
            ssi.scheduleInfo.hasNewSchedule = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function updatePrice(serviceItemId, priceInfo, index) {

            ServantCustom.updateServantService(serviceItemId, vm.servant.id).save(priceInfo, function (result) {

                priceInfo = result;
                $scope.$emit('tikonApp:servantUpdate', result);
                vm.isSaving = false;
                vm.editBtnPressed[index] = false;
            })

        }

        function checkCompanyActivityType() {

            if (vm.servant.company) {
                getActivityTYpeInfo(vm.servant.company.activityType);
            } else {
                CompanyCustom.getCurrentCompany().query(function (result) {
                    getActivityTYpeInfo(result.activityType);
                })
            }
        }

        function getActivityTYpeInfo(at) {
            ActivityTypeInfoCustom.getActivityTypeInfoByType(at).query(function (activity) {
                vm.activityTypeInfo = activity;
                if (activity && activity.servantType == "RESOURCE") {
                    vm.isWorkSpace = true;

                    vm.showAmenities = false;
                    vm.showImageGallery = false;
                    vm.showTags = false;
                    vm.isWorkSpace = true;
                    vm.serviceListEmptyMessage = 'هیچ خدماتی انتخاب نشده است.';

                    setServantTranslate();
                }
            })
        }

        function setServantTranslate() {

            if (vm.isWorkSpace) {
                vm.servantTranslate = $translate.instant('tikonApp.servant.home.title-space-v2');
            }
        }


        $scope.ActiveServiceFilter = function (item) {
            return item.serviceItem.serviceStatus != 'DISABLE';
        };
        $scope.ValidPriceInfoFilter = function (item) {
            return true;
            //   return (item.priceInfoDtails && item.priceInfoDtails.length>0);
        };


        var last = {
            bottom: false,
            top: true,
            left: true,
            right: false
        };

        vm.toastPosition = angular.extend({}, last);

        vm.getToastPosition = function () {
            sanitizePosition();

            return Object.keys(vm.toastPosition)
                .filter(function (pos) {
                    return vm.toastPosition[pos];
                }).join(' ');
        };

        function sanitizePosition() {
            var current = vm.toastPosition;

            if (current.bottom && last.top) {
                current.top = false;
            }
            if (current.top && last.bottom) {
                current.bottom = false;
            }
            if (current.right && last.left) {
                current.left = false;
            }
            if (current.left && last.right) {
                current.right = false;
            }

            last = angular.extend({}, current);
        }

        function showLimitDateChange(showLimitDates, datePeriod) {
            if (!showLimitDates) {
                datePeriod.fromDate = null;
                datePeriod.toDate = null;

            }

        }

        function checkShowLimitDates() {
            if (!vm.servant.scheduleInfo || !vm.servant.scheduleInfo.weeklyScheduleInfo)
                return;

            if (vm.servant.scheduleInfo.weeklyScheduleInfo.datePeriod.fromDate ||
                vm.servant.scheduleInfo.weeklyScheduleInfo.datePeriod.endDate
            ) {
                vm.showLimitDates = true;
            }


            angular.forEach(vm.serviceList, function (ssi) {
                if (ssi.scheduleInfo.weeklyScheduleInfo.datePeriod.fromDate ||
                    ssi.scheduleInfo.weeklyScheduleInfo.datePeriod.toDate
                ) {
                    ssi.showLimitDates = true;
                }
            })

        }

        function setTabActive(tabName) {
            switch (tabName) {
                case 'servantSchedule':
                    vm.showServantSchedule = true;
                    vm.showServantCloseTimes = false;
                    vm.showServantOpenTimes = false;
                    break;
                case 'servantCloseTimes':
                    vm.showServantSchedule = false;
                    vm.showServantCloseTimes = true;
                    vm.showServantOpenTimes = false;
                    break;
                case 'servantOpenTimes':
                    vm.showServantSchedule = false;
                    vm.showServantCloseTimes = false;
                    vm.showServantOpenTimes = true;
                    break;
            }
        }

        function getNavItemClass(itemName) {
            switch (itemName) {
                case 'servantSchedule':
                    if (vm.showServantSchedule)
                        return 'my-nav-button-active';
                    else
                        return '';
                case 'servantCloseTimes':
                    if (vm.showServantCloseTimes)
                        return 'my-nav-button-active';
                    else
                        return '';
                case 'servantOpenTimes':
                    if (vm.showServantOpenTimes)
                        return 'my-nav-button-active';
                    else
                        return '';
            }
        }

        function addClosedTimes() {
            addServantExceptionTimes('CLOSE');
        }

        function addOpenTimes() {
            addServantExceptionTimes('OPEN');
        }

        function addServantExceptionTimes(mode) {

            $state.go('supplierPanel-v2.companyServants.servantExceptionTimes', {
                availabilityMode: mode,
                defaultServantId: vm.servant.id
            });

        }

        function reloadServantExceptionDurations() {
            $rootScope.$broadcast('reloadServantExceptionDurationListEvent');
        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            if ($state.current.parent == 'supplierPanel-v2.dashboard') {
                $state.go('supplierPanel-v2.dashboard');
                return;
            }

            Principal.hasAuthority('ROLE_SERVANT_LOGIN')
                .then(function (result) {
                    if (result) {
                        if ($rootScope.fromState.name && $rootScope.fromState.name == 'supplierPanel-v2.more')
                            $state.go('supplierPanel-v2.more');
                        else
                            $state.go('supplierPanel-v2.dashboard');

                    } else {
                        $state.go('supplierPanel-v2.companyServants', $rootScope.fromStateParams);
                    }
                });
            // $state.go('supplierPanel-v2.companyServants');

        }

        function getModalTitle() {
            if (vm.servant.id)
                return 'tikonApp.servant.home.edit';
            else
                return 'tikonApp.servant.home.create';
        }

        function prepareServiceItemListForSave() {

            if (vm.allCompanyServiceList) {
                vm.servant.serviceItemList = [];
                angular.forEach(vm.allCompanyServiceList, function (item) {
                    if (item.checked)
                        vm.servant.serviceItemList.push(item);
                })
            }
        }

        function onServantServiceCheckChange(item) {
            if (item.checked)
                item.canRemoveCheck = true;
        }

        function onServiceServantScheduleTabClick() {
            if (!vm.isServiceScheduleLoading && !vm.isServiceScheduleLoaded) {
                vm.isServiceScheduleLoading = true;
                $timeout(function () {
                    loadServantServiceSchedules();
                }, 100);
            }

        }

    }
})();
